// The sheet and the layer drawn on it, locked together.
//
// THE BUG THIS EXISTS TO PREVENT.
//
// Geometry is percent of the sheet image, and the overlay is an <svg
// viewBox="0 0 100 100" preserveAspectRatio="none"> laid over an <img>.
// That only registers if the svg covers EXACTLY the image box. Put the
// pair in a container that is taller than the image - a flex child with
// `flex: 1`, or anything with a `minHeight` the drawing does not reach -
// and `inset: 0` stretches the svg over the container instead. Percent-Y
// then maps onto a taller box than the drawing and every run sits low,
// by a margin that changes with the window size.
//
// It bit twice: the layout pane (flex: 1, minHeight: 420) and the tracer
// (minHeight: 300). Two copies of one geometry rule is how they drifted,
// and the tracer's copy was the dangerous one - you would trace against
// one scale and the board would draw against another, so the coordinates
// were wrong the moment they were written.
//
// So the rule lives here, once: an inner box that SHRINK-WRAPS the image
// (width 100%, the image `display: block`, no height of its own), with
// the svg inset into that box and nothing else. Whatever the outer
// container does - stretch, scroll, centre - cannot reach the pair.
import React from "react";

export default function SheetStage({
  img,
  svgRef,
  cursor = "default",
  // Only used when there is no image to take a height from: a blank
  // stage still needs a box, or the svg collapses to nothing and the
  // page has no way to draw the first item on a project.
  blankAspect = "4 / 3",
  // The board fades the sheet so the runs read over it; the print wants
  // the drawing legible in its own right.
  imgOpacity = 0.45,
  onClick,
  onDoubleClick,
  onMouseDown,
  children,
  outerStyle,
}) {
  return (
    <div
      style={{
        position: "relative",
        overflow: "auto",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        ...outerStyle,
      }}
    >
      <div style={{ position: "relative", width: "100%", ...(img ? null : { aspectRatio: blankAspect }) }}>
        {img && (
          <img
            src={img}
            alt=""
            // display: block, or the inline baseline adds a few pixels of
            // descender space under the image and the svg is that much
            // taller than what it is registering to.
            style={{ width: "100%", display: "block", opacity: imgOpacity }}
          />
        )}
        <svg
          ref={svgRef}
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          style={{ position: "absolute", inset: 0, width: "100%", height: "100%", cursor }}
          onClick={onClick}
          onDoubleClick={onDoubleClick}
          onMouseDown={onMouseDown}
        >
          {children}
        </svg>
      </div>
    </div>
  );
}

// Where a pointer event landed, in the same percent space the geometry is
// stored in. Reads the SVG's own rect, which after the layout above IS
// the image's rect - so a click maps to the pixel it looks like it hit.
export function pointAt(svgEl, e) {
  const r = svgEl.getBoundingClientRect();
  if (!r.width || !r.height) return { x: 0, y: 0 };
  return {
    x: Math.round(((e.clientX - r.left) / r.width) * 1000) / 10,
    y: Math.round(((e.clientY - r.top) / r.height) * 1000) / 10,
  };
}
